<template>
  <div>
    <div class="row my-3">
      <div class="flex md6">
        <h5 :style="{ color: this.$themes.primary }">Etablissements et contacts secondaires</h5>
      </div>
      <div class="flex md6">
        <div class="row row-inside align-right">
          <va-button class="ml-3" color="info" @click="createNewEtablissement" icon="fa fa-plus" />
          <h4 style="position: relative;
          top: 0.6em;">Ajouter un Etablissement</h4>
        </div>
      </div>
    </div>
    <div class="row row-inside mt-3">
      <div class="flex md12">
        <template v-for="etablissement in etablissementList">
          <div class="row px-2 pt-2">
            <div class="flex md12">
              <div class="row px-2 pt-2">
                <div class="flex md6">
                  <h6 :style="{ color: $themes.primary }">
                    Etablissement
                    {{ etablissement.isSiege ? "siège" : "secondaire"
                    }}{{ etablissement.nom ? " - " + etablissement.nom : "" }} -
                    SIRET:
                    {{
                    etablissement.isSiege
                    ? entreprise.siret
                    : etablissement.siret
                    }}
                    <va-button
                      class="modify-etablissement-row"
                      flat
                      color="primary"
                      icon="fa fa-pencil"
                      @click="modifyEtablissement(etablissement)"
                    />
                  </h6>
                  <p>
                    {{ etablissement.adresse
                    }}{{
                    etablissement.complement
                    ? ", " + etablissement.complement
                    : ""
                    }},
                    {{ etablissement.code_postal + ", " + etablissement.ville }}
                    {{ etablissement.cedex ? ", " + etablissement.cedex : "" }}
                    <span
                      v-if="etablissement.adresse_envois_id"
                    >
                      &nbsp;|
                      <b>Adresse postale :</b>
                      {{ etablissement.adresse_env
                      }}{{
                      etablissement.complement_env
                      ? ", " + etablissement.complement_env
                      : ""
                      }},
                      {{
                      etablissement.code_postal_env +
                      ", " +
                      etablissement.ville_env
                      }}
                      {{
                      etablissement.cedex_env
                      ? ", " + etablissement.cedex_env
                      : ""
                      }}
                    </span>
                  </p>
                </div>
                <div class="flex md6">
                  <div class="row row-inside align-right">
                    <va-button
                      color="info"
                      @click="createNewContact(etablissement)"
                      icon="fa fa-plus"
                    />
                    <h4 style="position: relative;
          top: 0.6em;">Ajouter un contact</h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="row px-2 pt-2" v-if="etablissement.contactList.length">
              <div class="flex md12">
                <va-data-table
                  class="va-table--hoverable va-table--stripped"
                  :fields="fields"
                  :data="etablissement.contactList"
                  no-data-label="Aucun contact pour cet établissement"
                  clickable
                  @row-clicked="modifyContact"
                >
                  <template slot="nom_cust" slot-scope="props">
                    <p>{{ props.rowData.nom ? props.rowData.nom : "&nbsp;" }}</p>
                    <p class="small_font">{{ props.rowData.nom_societe }}</p>
                  </template>
                  <template slot="prenom_cust" slot-scope="props">
                    <p>
                      {{
                      props.rowData.prenom ? props.rowData.prenom : "&nbsp;"
                      }}
                    </p>
                    <p class="small_font">{{ props.rowData.prenom_societe }}</p>
                  </template>
                  <template slot="titre_cust" slot-scope="props">
                    <p>{{ props.rowData.titre ? props.rowData.titre : "&nbsp;" }}</p>
                    <p class="small_font">{{ props.rowData.titre_societe }}</p>
                  </template>
                  <template slot="telephone_cust" slot-scope="props">
                    <p>{{ formatPhoneNumber(props.rowData.telephone) }}</p>
                    <p>{{ formatPhoneNumber(props.rowData.portable) }}</p>
                  </template>
                  <template slot="gerant" slot-scope="props">
                    <va-button
                      class="modify-etablissement-row"
                      flat
                      :color="
                        props.rowData.isMain === 1 ? 'primary' : 'secondary'
                      "
                      icon="fa fa-user"
                      @click="changeMainContact(props.rowData)"
                    />
                  </template>
                </va-data-table>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <va-modal
      :title="editTitle"
      class="modal"
      v-model="showEditorContact"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveContact"
      v-on:cancel="closeModal"
    >
      <div class="row row-inside">
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex md6">
              <p>
                Etablissement ({{
                activeEtablissement.isSiege ? "siège" : "secondaire"
                }}){{
                activeEtablissement.nom ? ": " + activeEtablissement.nom : ""
                }}
              </p>
            </div>

            <div class="flex md6">
              <p>
                SIRET:
                {{
                activeEtablissement.siret
                ? activeEtablissement.siret
                : "siret inconnu"
                }}
              </p>
            </div>
          </div>
          <div class="row row-inside mt-3">
            <div class="flex md3 padded-input">
              <va-select
                label="Titre"
                v-model="activeContact.titre"
                :options="titreOptions"
                no-clear
              />
            </div>
            <div class="flex md5 padded-input">
              <va-input v-model="activeContact.nom" placeholder="-" label="Nom" :error="validName" />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-show="activeContact.titre !== 'SOCIÉTÉ'"
                :disabled="activeContact.titre === 'SOCIÉTÉ'"
                v-model="activeContact.prenom"
                placeholder="-"
                label="Prénom"
              />
            </div>
          </div>
          <div class="row row-inside" v-if="activeContact.titre === 'SOCIÉTÉ'">
            <div class="flex md3 padded-input">
              <va-select
                label="Titre contact"
                v-model="activeContact.titre_societe"
                :options="titreOptionsSociete"
                no-clear
              />
            </div>
            <div class="flex md5 padded-input">
              <va-input v-model="activeContact.nom_societe" placeholder="-" label="Nom contact" />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-model="activeContact.prenom_societe"
                placeholder="-"
                label="Prénom contact"
              />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md4 padded-input">
              <va-select
                label="Fonction"
                v-model="activeContact.fonction"
                :options="fonctionOptions"
              />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-model="phoneNumber"
                placeholder="Telephone"
                label="Telephone"
                :error="validFPhone"
                v-on:paste="trimOnPaste('telephone')"
                v-on:focus="phoneNumber = removeWhiteSpace(phoneNumber)"
                v-on:blur="phoneNumber = formatPhoneNumber(phoneNumber)"
              />
            </div>
            <div class="flex md4 padded-input">
              <va-input
                v-model="portableNumber"
                placeholder="Portable"
                label="Portable"
                :error="validPPhone"
                v-on:paste="trimOnPaste('portable')"
                v-on:focus="portableNumber = removeWhiteSpace(portableNumber)"
                v-on:blur="portableNumber = formatPhoneNumber(portableNumber)"
              />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md6 padded-input">
              <va-input v-model="activeContact.email" placeholder="-" label="Courriel" />
            </div>
            <div class="flex md3 padded-input">
              <va-toggle small v-model="journaltoggle" disable label="Reçoit le journal" />
            </div>
            <div class="flex md3 padded-input">
              <va-toggle small v-model="activeContact.isactif" label="Contact actif" />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex md12">
              <va-input
                v-model="activeContact.note"
                label="Commentaire:"
                type="textarea"
                autosize
                :minRows="5"
                :maxRows="5"
              />
            </div>
          </div>
          <va-checkbox label="Adresse de l'établissement" v-model="etsAdresse" />
          <dashboard-adresse-infos
            ref="adresseInfoComp"
            class="mt-3"
            :adresseInfos="activeAdresse"
            :isDisabled="etsAdresse"
            v-on:infosChanged="updateInfosA"
          />
          <div class="flex md12">
            <va-button
              v-if="isAdmin"
              v-show="activeContact.idcontact"
              class="fullwidth"
              large
              color="danger"
              @click="
                showConfirmDelete = true;
                toDelete = 'contact';
              "
            >Supprimer le contact</va-button>
          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      :title="editTitleEtablissement"
      class="modal"
      large
      v-model="showEditorEt"
      cancelClass="none"
      :okText="$t('ficheEntreprise.close')"
      cancelText="Annuler"
      v-on:ok="saveEtablissement"
      v-on:cancel="closeModal"
    >
      <div class="flex md12 padded-input">
        <div class="row row-inside">
          <div class="flex md6">
            <va-input
              v-model="inputSiret"
              placeholder="SIRET établissement"
              label="SIRET établissement"
              :error="validSiret"
              v-on:paste="trimOnPaste('siret')"
              v-on:focus="inputSiret = removeWhiteSpace(inputSiret)"
              v-on:blur="formatSiret()"
            />
          </div>
          <div class="flex md6">
            <va-input
              v-model="activeEtablissement.nom"
              placeholder="Nom établissement"
              label="Nom"
            />
          </div>
          <div class="flex md3">
            <va-input
              v-model="activeEtablissement.nb_salaries"
              placeholder="-"
              :error="validENumber"
              label="Nombre d'employés"
            />
          </div>

          <div class="flex md3">
            <va-toggle small v-model="activeEtablissement.isactif" label="En activité" />
          </div>
          <div class="flex md12 pl-2 mb-2">
            <h2>Adresse de l'établissement :</h2>
          </div>

          <dashboard-adresse-infos
            ref="adresseInfoComp"
            :adresseInfos="activeAdresse"
            v-on:infosChanged="updateInfosA"
          />
          <div class="flex md12 mb-3">
            <va-checkbox label="Adresse postale identique" v-model="adEnvois" />
          </div>
          <div class="flex md12 pl-2 mb-2" v-show="!adEnvois">
            <h2>Adresse postale :</h2>
          </div>

          <dashboard-adresse-infos
            v-show="!adEnvois"
            ref="adresseInfoCompEnvois"
            :adresseInfos="activeEnvoisAdresse"
            v-on:infosChanged="updateInfosAEnv"
          />
        </div>
        <div class="flex md6">
          <va-button
            v-if="isAdmin && !activeEtablissement.isSiege"
            v-show="activeEtablissement.idetablissement"
            class="fullwidth"
            large
            color="danger"
            @click="
              showConfirmDelete = true;
              toDelete = 'etablissement';
            "
          >Supprimer l'établissement</va-button>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      title="Confirmer la suppression"
      v-model="showConfirmDelete"
      :message="
        toDelete === 'etablissement'
          ? 'Voulez vous vraiment supprimer cet établissement'
          : 'Voulez vous vraiment supprimer ce contact'
      "
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deleteObject()"
    />
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, find, findIndex, orderBy, isEqual } from "lodash";
import DashboardAdresseInfos from "./DashboardAdresseInfos";
import { isPhoneNumber } from "../../../services/utils";

export default {
  name: "contactManager",
  components: {
    DashboardAdresseInfos,
  },
  props: ["entreprise"],

  data() {
    return {
      adEnvois: false,
      portableNumber: null,
      phoneNumber: null,
      infosEtablissementUpdated: false,
      inputSiret: null,
      showConfirmDelete: false,
      toDelete: null,
      isAction: false,
      etsAdresse: true,
      journaltoggle: true,
      etablissementList: [],
      okTextEtablissement: "Créer l'établissement",
      //TODO a preciser
      isAdmin:
        this.$store.getters.user.droits &&
        this.$store.getters.user.droits === "ADMIN",
      editTitle: "Fiche contact",
      editTitleEtablissement: "Nouvel établissement",
      showEditorContact: false,
      showEditorEt: false,
      activeEtablissement: this.resetEtablissement(),
      activeEtablissementComp: this.resetEtablissement(),
      activeEtablissementAdresse: this.resetAdresse(),
      activeAdresse: this.resetAdresse(),
      activeAdresseMod: this.resetAdresse(),
      activeAdresseModEnv: this.resetAdresse(),
      activeEnvoisAdresse: this.resetAdresse(),
      activeContact: this.resetContact(),
      activeContactComp: this.resetContact(),
      titreOptionsSociete: ["MONSIEUR", "MADAME"],
      titreOptions: ["MONSIEUR", "MADAME", "SOCIÉTÉ"],
      fonctionOptions: [
        "Président",
        "Gérant",
        "Co-gérant",
        "Ancien Gérant",
        "Directeur général",
        "DRH",
        "Expert-comptable",
        "Comptable",
        "Service Qualité",
        "Autre",
      ],
    };
  },
  mounted() {},
  computed: {
    ctFormNotValid: function () {
      // true :  not valid false: valid

      return this.validName || this.validFPhone || this.validPPhone;
    },
    etsFormNotValid: function () {
      // true :  not valid false: valid
      return this.validENumber || this.validSiret;
    },
    saveMessageEtablissement: function () {
      return this.infosEtablissementUpdated
        ? "Sauvegarder les modifications"
        : "Fermer la fiche";
    },
    validENumber: function () {
      if (!this.activeEtablissement.nb_salaries) return false;
      return !this.isNormalInteger(this.activeEtablissement.nb_salaries);
    },
    validSiret: function () {
      if (!this.inputSiret) return false;
      let str = this.removeWhiteSpace(this.inputSiret);
      let str0 = str.replace(/^[0]+/g, "");
      if (str.length === 14 && this.isNormalInteger(str0)) {
        return false;
      }
      return true;
    },
    validName: function () {
      if (!this.activeContact.nom) return true;
      return false;
    },
    validFPhone: function () {
      if (this.activeContact.telephone) {
        return !isPhoneNumber(this.activeContact.telephone);
      }
      return false;
    },
    validPPhone: function () {
      if (this.activeContact.portable) {
        return !isPhoneNumber(this.activeContact.portable);
      }
      return false;
    },
    fields() {
      return [
        {
          name: "__slot:gerant",
          title: "Gérant",
          width: "5%",
        },
        {
          name: "__slot:titre_cust",
          title: "Titre",
          //width: "20%"
        },
        {
          name: "__slot:nom_cust",
          title: "Nom",
          sortField: "nom",
          //width: "20%"
        },
        {
          name: "__slot:prenom_cust",
          title: "Prenom",
          //width: "20%"
        },

        {
          name: "__slot:journal",
          title: "Envoyer journal",
          //width: "15%"
        },
        {
          name: "fonction",
          title: "Fonction",
          //width: "15%"
        },
        {
          name: "__slot:telephone_cust",
          title: "Téléphone",
          //width: "15%"
        },
        {
          name: "email",
          title: "Courriel",
          //width: "15%"
        },
        {
          name: "note",
          title: "Note",
          //width: "15%"
        },
        {
          name: "__slot:statut",
          title: "Actif",
          //width: "15%"
        },
      ];
    },
  },
  methods: {
    trimOnPaste(entry) {
      if (entry == "siret") {
        setTimeout(() => {
          this.inputSiret = this.removeWhiteSpace(this.inputSiret);
        }, 200);
      }
      if (entry == "telephone") {
        setTimeout(() => {
          this.phoneNumber = this.removeWhiteSpace(this.phoneNumber);
        }, 200);
      }
      if (entry == "portable") {
        setTimeout(() => {
          this.portableNumber = this.removeWhiteSpace(this.portableNumber);
        }, 200);
      }
    },
    formatSiret() {
      if (!this.validSiret && this.inputSiret) {
        let siret = this.removeWhiteSpace(this.inputSiret);
        this.activeEtablissement.siret = siret;

        // 3 3 3 puis 5

        this.inputSiret =
          siret.slice(0, 3) +
          " " +
          siret.slice(3, 6) +
          " " +
          siret.slice(6, 9) +
          " " +
          siret.slice(9, 14);
      }
    },
    removeWhiteSpace(str) {
      if (str) return str.replace(/ /g, "");
      return null;
    },
    isNormalInteger(str) {
      var n = Math.floor(Number(str));
      return n !== Infinity && (String(n) === str || n === str) && n >= 0;
    },
    formatPhoneNumber(str) {
      if (str && isPhoneNumber(str)) {
        let newStr =
          str.slice(0, 2) +
          " " +
          str.slice(2, 4) +
          " " +
          str.slice(4, 6) +
          " " +
          str.slice(6, 8) +
          " " +
          str.slice(8, 10);
        return newStr;
      }
      return str;
    },
    async loadAll(identreprise) {
      let etablissementList = await axios.get("/api/list-etablissement", {
        params: {
          identreprise: identreprise,
        },
      });
      etablissementList.data.forEach((element) => {
        element.isSiege =
          element.idetablissement === this.entreprise.siege_id ? 1 : 0;
        element.contactList.forEach((contact) => {
          contact.isMain =
            contact.idcontact === element.contact_idcontact ? 1 : 0;

          contact.isactif =
            contact.isactif === null
              ? true
              : contact.isactif === 1
              ? true
              : false;
        });
        element.contactList = orderBy(element.contactList, "isMain", "desc");
        element.isactif =
          element.isactif === null
            ? true
            : element.isactif === 1
            ? true
            : false;
      });

      this.etablissementList = orderBy(
        etablissementList.data,
        "isSiege",
        "desc"
      );
    },
    async saveEtablissement() {
      this.showEditorEt = true;
      if (this.etsFormNotValid) {
        this.launchEpicmaxToast("Formulaire non valide");
        return;
      }
      try {
        this.activeEtablissement.nb_salaries = this.isNormalInteger(
          this.activeEtablissement.nb_salaries
        )
          ? this.activeEtablissement.nb_salaries
          : null;

        if (this.adEnvois) {
          this.activeAdresseModEnv = null;
        }

        if (this.activeEtablissement.idetablissement) {
          let params = {
            etablissement: this.activeEtablissement,
            adresse: this.activeAdresseMod,
            adresseEnvois: this.activeAdresseModEnv,
          };
          await axios.post("/api/update-etablissement", params);
        } else {
          // create
          this.activeEtablissement.entreprise_identreprise = this.entreprise.identreprise;

          let params = {
            etablissement: this.activeEtablissement,
            adresse: this.activeAdresseMod,
            adresseEnvois: this.activeAdresseModEnv,
          };
          await axios.post("/api/create-etablissement", params);
        }
        if (this.activeEtablissement.isSiege === 1) {
          this.$emit("updateEntreprise", 4);
        }
        this.showEditorEt = false;
        let preload = this.loadAll(this.entreprise.identreprise);
        this.activeAdresse = this.resetAdresse();
        this.activeEnvoisAdresse = this.resetAdresse();
        this.activeContact = this.resetContact();
        this.activeEtablissement = this.resetEtablissement();
        this.activeEtablissementAdresse = this.resetAdresse();
        await preload;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors de la sauvegarde - vérifier le formulaire"
        );

        console.log(error);
      }
    },
    async saveContact() {
      this.showEditorContact = true;
      if (this.ctFormNotValid) {
        this.launchEpicmaxToast("Formulaire non valide");
        return;
      }
      try {
        if (this.activeContact.titre === "SOCIÉTÉ") {
          this.activeContact.prenom = null;
        }
        // check that needed fields are set
        if (this.activeContact.idcontact) {
          //update

          let params = {
            contact: this.activeContact,
            adresse: this.activeAdresseMod,
            useOwnAdresse: !this.etsAdresse,
          };
          await axios.post("/api/update-contact", params);
        } else {
          // create
          this.activeContact.idetablissement = this.activeEtablissement.idetablissement;
          this.activeContact.entreprise_identreprise = this.entreprise.identreprise;

          let params = {
            contact: this.activeContact,
            adresse: this.activeAdresseMod,
            useOwnAdresse: !this.etsAdresse,
          };

          await axios.post("/api/create-contact", params);
        }
        this.$emit("updateEntreprise", 4);
        this.showEditorContact = false;
        let preload = this.loadAll(this.entreprise.identreprise);
        this.activeAdresse = this.resetAdresse();
        this.activeContact = this.resetContact();
        this.activeEtablissement = this.resetEtablissement();
        this.activeEtablissementComp = this.resetEtablissement();
        this.activeEtablissementAdresse = this.resetAdresse();
        await preload;
      } catch (error) {
        this.launchEpicmaxToast(
          "Erreur lors de la sauvegarde - vérifier le formulaire"
        );

        console.log(error);
      }
    },
    async changeMainContact(contact) {
      this.isAction = true;
      try {
        if (contact.idcontact && contact.idetablissement) {
          await axios.post("/api/main-contact", { contact: contact });
        }

        // modify the table without reload.
        let ijk = findIndex(this.etablissementList, [
          "idetablissement",
          contact.idetablissement,
        ]);
        this.etablissementList[ijk].contactList.forEach((element) => {
          if (element.idcontact === contact.idcontact) {
            element.isMain = 1;
          } else {
            element.isMain = 2;
          }
        });

        if (this.etablissementList[ijk].isSiege === 1) {
          this.$emit("updateEntreprise", 4);
        }
      } catch (error) {
        console.log(error);
      }
    },
    modifyContact(contact) {
      this.editTitle = "Fiche contact";

      if (this.isAction) {
        this.isAction = false;
        return;
      }
      this.etsAdresse = false;

      this.activeContact = this.resetContact(contact);
      let etablissement = find(this.etablissementList, [
        "idetablissement",
        contact.idetablissement,
      ]);
      this.activeEtablissement = this.resetEtablissement(etablissement);
      this.activeEtablissementAdresse = cloneDeep(
        this.resetAdresse(etablissement)
      );

      //own adresse or etablissement
      if (contact.id) {
        this.activeAdresse = cloneDeep(this.resetAdresse(contact));
      } else {
        this.etsAdresse = true;

        this.activeAdresse = cloneDeep(this.resetAdresse(etablissement));
      }
      this.activeAdresseMod = cloneDeep(this.activeAdresse);

      this.phoneNumber = this.activeContact.telephone
        ? this.formatPhoneNumber(this.activeContact.telephone)
        : null;
      this.portableNumber = this.activeContact.portable
        ? this.formatPhoneNumber(this.activeContact.portable)
        : null;

      this.showEditorContact = true;
    },
    modifyEtablissement(etablissement) {
      this.editTitleEtablissement = "Fiche établissement";

      this.activeEtablissement = this.resetEtablissement(etablissement);
      this.activeEtablissementComp = cloneDeep(this.activeEtablissement);
      this.inputSiret = this.activeEtablissement.siret
        ? this.activeEtablissement.siret
        : null;
      this.formatSiret();
      this.activeAdresse = cloneDeep(this.resetAdresse(etablissement));

      this.activeEtablissementAdresse = cloneDeep(
        this.resetAdresse(etablissement)
      );
      this.activeAdresseMod = this.resetAdresse(etablissement);
      this.activeEnvoisAdresse = this.resetAdresse({
        id: etablissement.adresse_envois_id,
        code_postal: etablissement.code_postal_env,
        ville: etablissement.ville_env,
        adresse: etablissement.adresse_env,
        complement: etablissement.complement_env,
        cedex: etablissement.cedex_env,
      });
      this.activeAdresseModEnv = cloneDeep(this.activeEnvoisAdresse);

      this.adEnvois = etablissement.adresse_envois_id ? false : true;

      this.showEditorEt = true;
    },
    resetEtablissement(value) {
      let etablissement;
      if (value) {
        etablissement = {
          entreprise_identreprise: this.entreprise.identreprise,
          idetablissement: value.idetablissement,
          siret: value.siret,
          nom: value.nom,
          adresse_id: value.adresse_id,
          contact_idcontact: value.contact_idcontact,
          isSiege: value.isSiege,
          nb_salaries: value.nb_salaries,
          isactif: value.isactif,
          adresse_envois_id: value.adresse_envois_id,
        };
      } else {
        etablissement = {
          entreprise_identreprise: this.entreprise.identreprise,
          idetablissement: null,
          siret: null,
          nom: null,
          idadresse: null,
          idcontact: null,
          nb_salaries: null,
          isactif: true,
          adresse_envois_id: null,
        };
      }
      return etablissement;
    },
    resetAdresse(value) {
      let adresse;
      if (value) {
        adresse = {
          id: value.id,
          code_postal: value.code_postal,
          ville: value.ville,
          adresse: value.adresse,
          complement: value.complement,
          cedex: value.cedex,
        };
      } else {
        adresse = {
          id: null,
          code_postal: null,
          ville: null,
          adresse: null,
          complement: null,
          cedex: null,
        };
      }
      return adresse;
    },
    resetContact(value) {
      let contact = {
        idcontact: null,
        entreprise_identreprise: this.entreprise.identreprise,
        idetablissement: null,
        telephone: null,
        portable: null,
        email: null,
        adresse_id: null,
        note: null,
        fonction: null,
        titre: null,
        nom: null,
        prenom: null,
        titre_societe: null,
        nom_societe: null,
        prenom_societe: null,
        isactif: true,
      };
      if (value) {
        contact = {
          idcontact: value.idcontact,
          entreprise_identreprise: value.entreprise_identreprise,
          idetablissement: value.idetablissement,
          telephone: value.telephone,
          portable: value.portable,
          email: value.email,
          adresse_id: value.adresse_id,
          note: value.note,
          fonction: value.fonction,
          titre: value.titre,
          nom: value.nom,
          prenom: value.prenom,
          titre_societe: value.titre_societe,
          nom_societe: value.nom_societe,
          prenom_societe: value.prenom_societe,
          isactif: value.isactif,
        };
      }

      return contact;
    },
    updateInfosA() {
      this.activeAdresseMod = cloneDeep(
        this.$refs.adresseInfoComp.adresseInfosMod
      );
    },
    updateInfosAEnv() {
      this.activeAdresseModEnv = cloneDeep(
        this.$refs.adresseInfoCompEnvois.adresseInfosMod
      );
    },
    createNewContact(etablissement) {
      this.editTitle = "Créer un nouveau contact";

      this.activeContact = this.resetContact();
      this.activeEtablissement = this.resetEtablissement(etablissement);
      this.activeEtablissementAdresse = cloneDeep(
        this.resetAdresse(etablissement)
      );

      this.activeAdresse = cloneDeep(this.resetAdresse(etablissement));
      this.activeAdresseMod = this.resetAdresse(etablissement);
      this.showEditorContact = true;
      this.phoneNumber = null;
      this.portableNumber = null;
    },
    createNewEtablissement() {
      this.editTitleEtablissement = "Créer un nouvel établissement";
      this.activeEtablissement = this.resetEtablissement();
      this.activeEtablissementComp = cloneDeep(this.activeEtablissement);

      this.inputSiret = null;
      this.activeAdresse = this.resetAdresse();
      this.activeEnvoisAdresse = this.resetAdresse();
      this.activeAdresseModEnv = cloneDeep(this.activeEnvoisAdresse);

      this.adEnvois = false;
      this.showEditorEt = true;
    },
    closeModal() {
      this.adEnvois = false;
      this.activeEtablissement = this.resetEtablissement();
      this.activeAdresse = this.resetAdresse();
      this.activeEnvoisAdresse = this.resetAdresse();
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
    async deleteObject() {
      try {
        if (this.toDelete === "etablissement") {
          await axios.delete("/api/delete-etablissement", {
            data: {
              idetablissement: this.activeEtablissement.idetablissement,
            },
          });

          this.showEditorEt = false;
        } else if (this.toDelete === "contact") {
          await axios.delete("/api/delete-contact", {
            data: {
              idcontact: this.activeContact.idcontact,
            },
          });
          this.showEditorContact = false;
        }
        this.activeContact = this.resetContact();
        this.activeEtablissement = this.resetEtablissement();
        this.activeAdresse = this.resetAdresse();
        this.loadAll(this.entreprise.identreprise);
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    phoneNumber(newNumber) {
      if (newNumber) {
        this.activeContact.telephone = this.removeWhiteSpace(newNumber);
      } else if (newNumber === null || newNumber === "") {
        this.activeContact.telephone = null;
      }
    },
    portableNumber(newNumber) {
      if (newNumber) {
        this.activeContact.portable = this.removeWhiteSpace(newNumber);
      } else if (newNumber === null || newNumber === "") {
        this.activeContact.portable = null;
      }
    },
    activeEtablissement: {
      deep: true,
      handler() {
        if (!isEqual(this.activeEtablissementComp, this.activeEtablissement)) {
          this.infosEtablissementUpdated = true;
        } else {
          this.infosEtablissementUpdated = false;
        }
      },
    },
    inputSiret(newSiret) {
      if (newSiret) {
        this.activeEtablissement.siret = this.removeWhiteSpace(this.inputSiret);
      }
    },
    etsAdresse(newValue, oldValue) {
      if (newValue && !oldValue) {
        this.activeAdresse = this.resetAdresse(this.activeEtablissementAdresse);
      }
      if (!newValue && oldValue) {
        // this.activeAdresse = this.resetAdresse();
      }
    },

    entreprise(newentreprise) {
      if (newentreprise) {
        this.loadAll(newentreprise.identreprise);
      } else {
      }
    },
  },
};
</script>

<style lang="scss">
.padded-input {
  padding-left: 0.25rem;
}
.modify-etablissement-row {
  top: 0.5em;
}
.forcewidth-create-contact {
  width: 75vw;
  height: 60vh;
}

.large_font {
  font-size: 1.1em;
}
.small_font {
  font-size: 0.8em;
}
</style>
